<app-modal-panel #modalPanel [headerTitle]="title" buttonTitle="save link" [allowSubmit]="linkForm.form.valid" (submit)="onSave()">
    <div class="content">

      <div class="modal-body pt-0 pb-0">
        <div class="modal-content border-0">
          <form #linkForm="ngForm" novalidate (ngSubmit)="onSave()">
            <div class="row">
              <div class="col-sm-12 mb-1">
                <span class='title'>Display Name*</span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <input inputFocus name="name" class="form-control border-0" type="text"
                  [(ngModel)]="usefulLink.displayName" [attr.placeholder]="'Display Name'" required>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 mt-3 mb-1">
                <span class='title'>Link*</span>
              </div>
            </div>
            <div class="row mb-4">
              <div class=	"col-sm-12">
                <input inputFocus name="link" class="form-control border-0" type="text"
                  [(ngModel)]="usefulLink.link" [attr.placeholder]="'Link'" required>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </app-modal-panel>
